/** Verrou synchrone — bloque la sync IMAP live pendant save-draft.php (1 connexion à la fois). */
let draftSaveInFlight = false;

export function isDraftSaveInFlight(): boolean {
  return draftSaveInFlight;
}

export function setDraftSaveInFlight(active: boolean): void {
  draftSaveInFlight = active;
}
